import * as React from "react";
import TableHead from "@mui/material/TableHead";
import { TableRow, TableSortLabel } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort, columns } = props;

  const createSortHandler = (property) => (event) => {
    if (onRequestSort) {
      onRequestSort(event, property);
    }
  };

  return (
    <TableHead className="table-header">
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.align}
            style={{ minWidth: column.minWidth, ...column.styleHeader }}
          >
            {column.sortable && (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : "asc"}
                onClick={createSortHandler(column.id)}
              >
                {column.label}
                {orderBy === column.id ? (
                  <Box
                    component="span"
                    sx={{
                      border: 0,
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      margin: -1,
                      overflow: "hidden",
                      padding: 0,
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}

            {!column.sortable && <>{column.label}</>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
